import React from "react";
import SolutionListingPresenter from "./SolutionList.presenter";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { MapStateToProps, MapDispatchToProps, C_Props, MergedProps, C_States } from "./SolutionList.type";
import { SolutionOutputModel, RootState, TCb, LanguageOutputModel } from "../../../../../models";
import { NotificationActions, AllLanguageListActions } from "../../../../../store/actions";
import _ from "lodash";

import { APP_ROUTES, INITIAL_FETCHING_PAGINATION_DATA } from "../../../../../constants";

import { SolutionService } from "../../../../../services";
import { loadCallback, SolutionUtil } from "../../../../../utils";
import { withRouter } from "react-router-dom";

const EMPTY_FILTER: C_States["filter"] = {
  searchValue: "",
};

class SolutionListingContainer extends React.Component<MergedProps, C_States> {
  constructor(props) {
    super(props);
    const solutionPageCode = this.props.match.params.solutionCode;

    this.state = {
      filter: EMPTY_FILTER,
      fetchedSolution: INITIAL_FETCHING_PAGINATION_DATA,
      visibleSolutionCode: solutionPageCode,
      visibleSolutionForm: Boolean(solutionPageCode),

      activeLanguageId: "",
      languageData: [],
      amountPost: 0,
    };
  }

  openSolutionFormModal = (solutionCode?: string) => {
    this.setState({ visibleSolutionCode: solutionCode, visibleSolutionForm: true }, () => {
      if (solutionCode) {
        this.props.history.push(SolutionUtil.buildSolutionDetailPath(solutionCode));
      }
    });
  };

  closeSolutionFormModal = (cb?: TCb) => {
    this.props.history.push(APP_ROUTES.PAGEMANAGEMENT.SOLUTION.BASE);
    this.setState({ visibleSolutionCode: undefined, visibleSolutionForm: false }, () => {
      loadCallback(cb?.success);
    });
  };

  countPost = (dataPost: SolutionOutputModel[]) => {
    const data: any = dataPost;
    const uniqueObj = {};
    for (var i = 0; i < data.length; i++) {
      uniqueObj[data[i]] = 1 + (uniqueObj[data[i]] || 0);
    }
    const count = uniqueObj[Object.keys(uniqueObj)[Object.keys(uniqueObj).length - 1]];
    // Khi data = [] => count: undefined
    if (count) {
      this.setState({
        amountPost: count,
      });
    }
  };

  onSearch = _.debounce((searchValue: string) => {
    this.setState(
      (prevState) => {
        return {
          filter: {
            ...prevState.filter,
            searchValue,
          },
        };
      },
      () => {
        this.onApplyFilter(false);
      }
    );
  }, 300);

  onApplyFilter = (loadMore: boolean, cb?: TCb) => {
    if (this.state.fetchedSolution.loading && loadMore) return;
    this.props.all_language_list.data.forEach((e: LanguageOutputModel) => {
      if (e.isPrimary) {
        this.setState({
          activeLanguageId: e.id,
        });
      }
    });

    this.setState(
      (prevState) => {
        return {
          fetchedSolution: {
            ...prevState.fetchedSolution,
            data: loadMore ? prevState.fetchedSolution.data : [],
            loading: true,
          },
        };
      },
      () => {
        const query: Parameters<typeof SolutionService.getAllSolutionPageByLanguage>[0] = {
          languageId: this.state.activeLanguageId,
        };

        SolutionService.getAllSolutionPageByLanguage(query)
          .then((res) => {
            this.countPost(res.data.data);
            if (res && res.data?.data) {
              this.setState(
                (prevState) => {
                  let solutionPages: SolutionOutputModel[] = [...res.data.data];

                  if (loadMore) {
                    solutionPages.unshift(...prevState.fetchedSolution.data);
                  }

                  return {
                    fetchedSolution: {
                      ...res.data,
                      data: solutionPages,
                      loading: false,
                    },
                  };
                },
                () => {
                  loadCallback(cb?.success);
                }
              );
            } else {
              this.setState({
                fetchedSolution: INITIAL_FETCHING_PAGINATION_DATA,
              });
            }
          })
          .catch((err) => {
            this.setState({
              fetchedSolution: INITIAL_FETCHING_PAGINATION_DATA,
            });
          });
      }
    );
  };

  onLoadMore = () => {
    this.onApplyFilter(true);
  };

  componentDidMount() {
    if (!this.props.all_language_list.data.length) {
      this.props.actions.getAllLanguages({
        success: () => {
          this.onApplyFilter(false);
        },
      });
    } else {
      this.onApplyFilter(false);
    }
  }

  render() {
    return (
      <SolutionListingPresenter
        {...this.props}
        {...this.state}
        onLoadMore={this.onLoadMore}
        onSearch={this.onSearch}
        openSolutionFormModal={this.openSolutionFormModal}
        closeSolutionFormModal={this.closeSolutionFormModal}
        reloadListingPage={() => {
          this.onApplyFilter(false);
        }}
      />
    );
  }
}

export default withRouter<C_Props, any>(
  connect<MapStateToProps, MapDispatchToProps, C_Props, RootState>(
    (state: RootState) => ({
      all_language_list: state.all_language_list,
    }),
    (dispatch: Dispatch) => ({
      actions: bindActionCreators(Object.assign(NotificationActions, AllLanguageListActions), dispatch),
    })
  )(SolutionListingContainer)
);
